import axios from "axios";
import constant from "../utilities/constants.json";
import { setSiteUnderMaintenanceOutsideReact } from "../utilities/reducer";
let url = constant.server;
export const predictGameAnswer = (data) => {
  return axios
    .post(url + "predict_game_answer", data, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: "Bearer " + `${localStorage.webKey}`,
      },
    })
    .then((response) => {
      return response;
    })
    .catch((err) => {
      // console.log(err);
    });
};

export const leaderboardDetails = (data) => {
  return axios
    .post(url + "get_leaderboard", data, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: "Bearer " + `${localStorage.webKey}`,
      },
    })
    .then((response) => {
      if (response.data.status == 1) {
        return response;
      } else if (response.data.status == 101 || response.data.status == 102) {
        localStorage.clear();
        window.location.href = "/";
        return response;
      } else if (response.data.status === 103)
        setSiteUnderMaintenanceOutsideReact();
    })
    .catch((err) => {
      console.log(err);
    });
};